export function base64EncodeBinary(data: Uint8Array) {
  // JavaScript engines have a limit to the number of arguments, choose a safe value
  const maxArgs = 4096;
  const strs: string[] = [];
  for (let i = 0; i < data.length; i += maxArgs) {
    strs.push(String.fromCharCode(...data.subarray(i, i + maxArgs)));
  }

  // Intentionally disable esline rule, since this is a safe wrapper around btoa
  /* oxlint-disable-next-line core/no-restricted-syntax */ // eslint-disable-next-line no-restricted-syntax
  return btoa(strs.join(''));
}

export function base64EncodeBinaryURL(data: Uint8Array) {
  const base64 = base64EncodeBinary(data);
  // + => -
  // / => _
  // No '=' padding
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function base64Encode(data: string) {
  const encoder = new TextEncoder();
  return base64EncodeBinary(encoder.encode(data));
}

export function base64DecodeBinary(encoded: string) {
  // Intentionally disable esline rule, since this is a safe wrapper around atob
  /* oxlint-disable-next-line core/no-restricted-syntax */ // eslint-disable-next-line no-restricted-syntax
  return Uint8Array.from(atob(encoded), (char) => char.charCodeAt(0));
}

export function base64DecodeBinaryURL(encoded: string) {
  // - => +
  // _ => /
  // '=' padding doesn't need to be added, atob figures it out for us
  return base64DecodeBinary(encoded.replace(/-/g, '+').replace(/_/g, '/'));
}

export function base64Decode(encoded: string) {
  const decoder = new TextDecoder();
  return decoder.decode(base64DecodeBinary(encoded));
}
